<template>
  <div v-loading="loading">
    <div
      v-if="!loading && (data === null || data.length < 1)"
      class="empty-text"
    >
      <i class="el-icon-warning-outline"></i>
      {{ emptyText || this.$t('RestCards_Text_NoDataFound') }}
    </div>

    <el-row v-else>
      <el-col :span="12" v-for="(item, index) in data" :key="index">
        <slot :item="item"></slot>
      </el-col>
    </el-row>

    <el-pagination
      v-if="maxPages > 1"
      background
      class="paginator"
      :layout="paginationLayout"
      :page-count="maxPages"
      :current-page="currentPage"
      @current-change="pageChange"
    ></el-pagination>
  </div>
</template>

<script>
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import memoize from 'memoizee'

const fetchPage = memoize(
  (page, paginator, params) => paginator.fetchPage(page),
  {
    promise: true,
    maxAge: 10000
  }
)

export default {
  name: 'RestCardsNew',

  props: {
    fetchEndpoint: {
      required: true,
      type: Object
    },

    emptyText: {
      retuired: false,
      type: String
    }
  },

  data() {
    return {
      data: [],
      paginator: {},
      maxPages: 1,
      currentPage: 1,
      paginationLayout: 'prev, pager, next',
      loading: false
    }
  },

  mounted() {
    this.paginator = new RestApiPaginator(this.fetchEndpoint)
    this.fetchPage(1)
  },

  methods: {
    async pageChange(val) {
      await this.fetchPage(val)
    },

    async fetchPage(page) {
      this.loading = true
      try {
        let response = await fetchPage(
          page,
          this.paginator,
          JSON.stringify(this.paginator.params)
        )
        this.maxPages = Number.parseInt(
          response.headers['x-pagination-page-count']
        )
        this.currentPage = Number.parseInt(
          response.headers['x-pagination-current-page']
        )

        this.paginationLayout =
          Number.parseInt(response.headers['x-pagination-total-count']) === -1
            ? 'prev, next'
            : 'prev, pager, next'

        this.data = response.data
      } catch (error) {
        this.data = null
        this.$message({
          message: error.message,
          type: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.paginator {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1d87c8;
}

>>> .el-pagination.is-background .btn-prev,
>>> .el-pagination.is-background .btn-next,
>>> .el-pagination.is-background .el-pager li {
  background-color: #fff;
}

.empty-text {
  font-size: 15px;
  color: #acb0b5;
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestCardsNew.vue